/**
 * ObjectIframeField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// application
import {completeFrameURL} from "../../operations/editing";


// TODO: better remove this class and solve CBox preview differently


/**
 * ObjectIframeField is an editing component for iframe fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectIframeField extends React.Component {

    render() {

        const { classes, fieldDef } = this.props;

        const url = this.props.completeFrameURL(this.props.objectId, fieldDef.url);

        return (
            <div>
                <div className={classes.iframeContainer}>
                    <iframe title="view"
                        id={fieldDef.id}
                        className={classes.iframeElement}
                        src={url}
                        referrerPolicy="no-referrer"
                    />
                </div>
                <div><a href={url} target="_blank" rel="noopener noreferrer">öffnen</a></div>
            </div>
        );
    }
}

ObjectIframeField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    iframeContainer: {
        position: "relative",
        paddingTop: "56.25%" // 16:9
    },
    iframeElement: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderStyle: "none"
    }
};

export default connect(null, {completeFrameURL})(withStyles(styles)(ObjectIframeField));